const groupCls = "_275gs4q8c0";
const itemCls = "_275i1qvsndh";

export { groupCls, itemCls };
import "./atom.group.style.linaria.module.css";
//# sourceMappingURL=atom.group.style.js.map
